// authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MyObject {
    [key: string]: any;
}
interface LoginState {
    email: string;
    faceID: string;
    password: string;
    accessToken: string;
    userID: string;
    isEmailVerified: boolean;
    entityAccountUserDetails: MyObject;
    entityAccountBusinessDetails: MyObject;
    wizardPageNumber: number;

}



const initialState: LoginState = {
    email: '',
    faceID: '',
    password: '',
    accessToken: '',
    userID: '',
    isEmailVerified: false,
    entityAccountUserDetails: {},
    entityAccountBusinessDetails: {},
    wizardPageNumber: 1,

};

// Create your auth slice
const LoginReducer = createSlice({
    name: 'loginAccount',
    initialState,
    reducers: {
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setFaceID: (state, action: PayloadAction<string>) => {
            state.faceID = action.payload;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
        setAccessToken: (state, action: PayloadAction<string>) => {
            state.accessToken = action.payload;
        },
        setUserID: (state, action: PayloadAction<string>) => {
            state.userID = action.payload;
        },
        setEmailVerify: (state, action: PayloadAction<boolean>) => {
            state.isEmailVerified = action.payload;
        },

        setEntityAccountUserDetails: (
            state,
            action: PayloadAction<{ [key: string]: any }>
        ) => {
            state.entityAccountUserDetails = { ...action.payload };
        },

        setEntityAccountBusinessDetails: (
            state,
            action: PayloadAction<{ [key: string]: any }>
        ) => {
            state.entityAccountBusinessDetails = { ...action.payload };
        },
        setwizardPageNumber: (state, action: PayloadAction<number>) => {
            state.wizardPageNumber = action.payload;
        },

    },
});

export const { setEmail, setFaceID, setPassword, setAccessToken, setEmailVerify, setUserID, setEntityAccountUserDetails, setEntityAccountBusinessDetails, setwizardPageNumber } = LoginReducer.actions;
export default LoginReducer.reducer;
